var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 text-center"},[_c('label',{ref:"validationRef",staticClass:"text-danger mb-0"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }